<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-back-button color="white" slot="start" defaultHref="" (click)="closeModal()" text="" icon="chevron-back">
      </ion-back-button>

    </ion-toolbar>
  </ion-header>

  <ion-grid class="ion-no-padding description-grid">
    <ion-row >
      <ion-col size="12">
        <ion-slides #slides [options]="sliderOpts" [pager]="true">
          <ion-slide *ngFor="let image of item.images">
            <img [src]="image.url">
          </ion-slide>
        </ion-slides>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="p-0">
    <ion-row class="buttons" *ngIf="
        item.show_email ||
        item.show_phone_number ||
        item.location_description ||
        item.virtual_tour_url || 
        item.web_site_url || 
        item.youtube || 
        item.instagram || 
        item.show_map_location ||
        item.facebook  &&
        ( authServ.isLogged)
      ">
      <ion-col size="2" *ngIf="item.show_email">
        <ion-button label="email" appEqualWidthHeight equalWith="width" href="mailto:{{ item.email }}">
          <ion-icon slot="icon-only" name="mail-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="item.show_phone_number">
        <ion-button label="call" appEqualWidthHeight equalWith="width" href="tel:{{ item.phone }}">
          <ion-icon slot="icon-only" name="call-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="item.web_site_url">
        <ion-button label="website" appEqualWidthHeight equalWith="width"
          (click)="modalServ.openLink(item.web_site_url)">
          <ion-icon slot="icon-only" name="earth-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- <ion-col size="2" *ngIf="
          item.location_description 
        ">
        <ion-button label="google_map_directions" appEqualWidthHeight equalWith="width"
          href="{{item.location_description}}" target="_blank">
          <ion-icon slot="icon-only" name="location-outline"></ion-icon>
        </ion-button>
      </ion-col> -->

      <ion-col size="2" *ngIf="
          item.show_map_location &&
          item.map_location
        ">
        <ion-button label="google_map_directions" appEqualWidthHeight equalWith="width" href="https://www.google.com/maps/dir/?api=1&destination={{
            item.map_location
          }}" target="_blank">
          <ion-icon slot="icon-only" name="location-outline"></ion-icon>
        </ion-button>
      </ion-col>


      <ion-col size="2" *ngIf="
          item.show_virtual_tour &&
          (item.virtual_tour_url | caption)
        ">
        <ion-button label="virtual_tour" appEqualWidthHeight equalWith="width"
          (click)="modalServ.openLink(item.virtual_tour_url)">
          <ion-icon slot="icon-only" name="locate-outline"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="2" *ngIf="item.youtube">
        <ion-button label="call" appEqualWidthHeight equalWith="width" target="_blank" href="{{ item.youtube }}">
          <ion-icon slot="icon-only" name="logo-youtube"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="2" *ngIf="item.instagram">
        <ion-button label="call" appEqualWidthHeight equalWith="width" target="_blank" href="{{ item.instagram }}">
          <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="2" *ngIf="item.facebook">
        <ion-button label="call" appEqualWidthHeight equalWith="width" target="_blank" href="{{ item.facebook }}">
          <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid class="ion-no-padding">
    <ion-row class="item-details">
      <ion-col size="10">
        <ion-text color="primary">
          <h2>{{item.name | caption}}</h2>
        </ion-text>

        <ng-container *ngIf="dataServ.menuItem.show_price">
          <ng-container *ngIf="price.activate_offer && dataServ.rData.discount_for_only_member">

            <ng-container *ngIf="authServ.isLogged;else noDiscount">
              <ion-text color="success">
                <ng-container *ngIf="userLang;else otherLang">
                  <ion-text color="medium">
                    <s>{{price.price}}{{price.currency_code}}</s>
                  </ion-text>
                  <b> {{price.offer_price}}{{price.currency_code}}</b>
                </ng-container>
                <ng-template #otherLang>
                  <ion-text color="medium">
                    <s>{{price.currency_code}} {{price.price}}</s>
                  </ion-text>
                  <b> {{price.currency_code}} {{price.offer_price}}</b>
                </ng-template>
              </ion-text>
            </ng-container>
            <ng-template #noDiscount>
              <ion-text color="medium" *ngIf="price.price > 0">
                <ng-container *ngIf="userLang==='tr';else otherLang">
                  <b>{{price.price}} {{price.currency_code}}</b>
                </ng-container>
                <ng-template #otherLang>
                  <ion-text color="medium">
                    <b>{{price.currency_code}} {{price.price}}</b>
                  </ion-text>
                </ng-template>
              </ion-text>
            </ng-template>
          </ng-container>
          <ng-template *ngIf="!price.activate_offer && dataServ.rData.discount_for_only_member; else standart">
            <ion-text color="success">
              <ng-container *ngIf="userLang;else otherLang">
                <ion-text color="medium">
                  <s>{{price.price}}{{price.currency_code}}</s>
                </ion-text>
                <b> {{price.offer_price}}{{price.currency_code}}</b>
              </ng-container>
              <ng-template #otherLang>
                <ion-text color="medium">
                  <s>{{price.currency_code}} {{price.price}}</s>
                </ion-text>
                <b> {{price.currency_code}} {{price.offer_price * dataServ.rData.general_discount_percentage / 100}}</b>
              </ng-template>
            </ion-text>
          </ng-template>
          <ng-template #standart>
            <ion-text color="medium" *ngIf="price.price > 0">
              <ng-container *ngIf="userLang==='tr';else otherLang">
                <b>{{price.price}} {{price.currency_code}}</b>
              </ng-container>
              <ng-template #otherLang>
                <ion-text color="medium">
                  <b>{{price.currency_code}} {{price.price}}</b>
                </ion-text>
              </ng-template>
            </ion-text>
          </ng-template>
          <ion-text color="primary" class="tl">
            <p>{{item.description | caption}}</p>
          </ion-text>


        </ng-container>
        <!-- <ion-grid *ngIf="allergens.length>0">
          <ion-row>
            <ion-col size="2" *ngFor="let allergen of allergens">
              <img [src]="allergen.image_url" [alt]="allergen.code">
              <p>{{ allergen.name | caption }}</p>
            </ion-col>
          </ion-row>
        </ion-grid> -->
      </ion-col>

    </ion-row>

  </ion-grid>
  <ion-grid>
    <ion-row>
      <ion-col size="10">
        <ng-container *ngIf="item.show_dress_code">
          <ion-item class="ion-no-border" lines="none">
            <ion-icon color="primary" slot="start" name="shirt-outline"></ion-icon>
            <ion-label color="primary">
              <b>{{ "Dress Code" | translate }}</b> <br />
              {{ item.dress_code | caption | translate }}
            </ion-label>
          </ion-item>
        </ng-container>
      </ion-col>
      <ng-container *ngIf="item.show_bullet_list">
        <ion-col size="10">
          <ion-text color="dark">
            <ul>
              <ng-container *ngFor="let bullet of bulletList">
                <li *ngIf="bullet.title | caption | translate">
                  <span [innerHtml]="bullet.title | caption | translate"></span>
                </li>
              </ng-container>
            </ul>
          </ion-text>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
  <ion-text color="primary" *ngIf="allergens.length>0">
    <h3>{{"Allergens" | translate}}</h3>
  </ion-text>
  <div class="allergen-list" *ngIf="allergens.length>0">
    <div class="allergen-item" *ngFor="let allergen of allergens">
      <div class="thumbnail-container">
        <img src="{{ allergen.image_url }}" alt="{{ allergen.code }}">
      </div>
      <div class="code-field">{{ allergen.name | caption }}</div>
    </div>
  </div>
</ion-content>